<template>
    <section class="row lp-blog-list pb-lg-4" :class="[classes ? classes : '']">
            <div class="col-12">
            <div class="row g-md-3 g-lg-4" v-if="mappedPosts.length > 0">
                <div v-for="(post, postIndex) in mappedPosts"
                     :class="[
                        postIndex % 10 == 0 
                            ? 'col-md-6 col-xxl-12 mb-3 mb-lg-0' 
                            : 'col-md-6 col-xxl-4 mb-3 mb-lg-0',
                        ]"
                     :key="`blog-post-${postIndex}`">
                    <blog-post-card :post="post" :post-index="postIndex" />
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12">
                    <h3>No posts available</h3>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { computed, reactive } from 'vue';
    import BlogFeaturedPosts from './BlogFeaturedPosts.vue';
    import BlogPostCard from './BlogPostCard.vue';

    export default {
        components: { BlogFeaturedPosts, BlogPostCard },
        name: 'BlogListFull',
        props: {
            classes: {
                type: String,
            },
            posts: {
                type: Array,
                required: true,
            },
        },
        setup(props) {

            // FEATURED POSTS
            const featuredPosts = reactive([]);

            const mappedPosts = computed(() => {
                let posts = props.posts.map((post) => ({ ...post }));
                return posts;
            });

            return {
                featuredPosts,
                mappedPosts,
            };
        },
    };
</script>

<style lang="scss"></style>